'use client';

import { useEffect, useState } from 'react';

import { useScreenSize } from '@/hooks/useScreenSize';

import { BlockReference } from '@/cms/types/block';
import { nextApiEndpoint } from '@/constant/env';

import { LiveChatPlaceholder } from '@/components/organisms/SocialWidget/LiveChatPlaceholder';
import { LiveChatWidget } from '@/components/organisms/SocialWidget/LiveChatWidget';
import SocialWidgetStrapi, {
  SocialWidgetStrapiProps,
} from '@/components/organisms/SocialWidget/SocialWidgetStrapi';

type SocialWidgetPayload = BlockReference<SocialWidgetStrapiProps>;

const Socials = () => {
  const { isDesktop: shouldShowWidget } = useScreenSize();

  const [widgetData, setWidgetData] = useState<SocialWidgetPayload | null>(
    null
  );

  useEffect(() => {
    if (!shouldShowWidget) {
      return;
    }

    fetch(`${nextApiEndpoint}/social-widget`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Social widget fetch failed: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        setWidgetData(response as SocialWidgetPayload);
      })
      .catch(() => {});
  }, [shouldShowWidget]);

  if (!shouldShowWidget) {
    return (
      <>
        <LiveChatPlaceholder />
        <LiveChatWidget />
      </>
    );
  }
  if (!widgetData?.data?.attributes) {
    return null;
  }

  return <SocialWidgetStrapi block={widgetData.data.attributes} />;
};

export default Socials;
